import appConfig from 'app-config';

/**
 * Custom Service class to call api for CIAM
 */
export default class CustomCIAMService {

    static async getCIAMAccessToken() {

        return await fetch(appConfig.env.CIAM_PH_INVITE_TOKEN_URL, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Ocp-Apim-Subscription-Key": appConfig.env.CRM_OCP_SUBSCRIPTION_KEY
            }
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Token request failed: ${response.status}`);
                }
                return response.json();
            })
            .then(data => data.access_token);
    }

    static async inviteUser(accessToken, email, firstName, lastName) {
        const applicationId = appConfig.env.CIAM_PH_INVITE_APP_ID;
        try {
            const apiUrl = appConfig.env.CIAM_PH_INVITE_API_URL.replace("{applicationId}", applicationId);

            const payload = {
                email: email,
                lastName: lastName,
                firstName: firstName,
                applicationId: applicationId,
                redirectUrl: `${window.location.origin}/create-account/subscribe`,
                sendMail: false,
                roleGroupAssignments: "",
                policyOverride: appConfig.env.CIAM_PH_INVITE_POLICY_OVERRIDE,
                designId: "",
                logonAuthority: "b2clogin"
            };

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "application/json",
                    "Ocp-Apim-Subscription-Key": appConfig.env.CRM_OCP_SUBSCRIPTION_KEY
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error(`HTTP Error: ${response.status}`);
            }

            const data = await response.json();

            return String(data.commandId);
        } catch (error) {
            console.error("Error inviting user:", error);
            throw error;
        }
    }

    static async validateInvitation(
        commandId,
        accessToken
    ) {
        try {
            const apiUrl = appConfig.env.CIAM_PH_FETCH_CMND_API_URL.replace(
                "{commandId}",
                encodeURIComponent(commandId)
            );

            let status = "";
            let responseObj = null;

            for (
                let counter = 0;
                counter < 5 && status !== "Finished";
                counter++
            ) {
                if (counter > 0) {
                    await new Promise(resolve => setTimeout(resolve, 1000));
                }

                const response = await fetch(apiUrl, {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "Content-Type": "application/json",
                        "Ocp-Apim-Subscription-Key": appConfig.env.CRM_OCP_SUBSCRIPTION_KEY
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP Error: ${response.status}`);
                }

                responseObj = await response.json();
                status = responseObj.status;

                console.log(`Status for iteration ${counter}: ${status}`);
            }

            const userInvitationDto = {
                status
            };

            if (status === "Finished" && responseObj) {
                if (
                    responseObj.affectedEntities &&
                    responseObj.affectedEntities.length > 0
                ) {
                    const properties =
                        responseObj.affectedEntities[0].properties || {};

                    userInvitationDto.invitationUrl =
                        properties.invitationRedemptionLink || "";

                    userInvitationDto.userId =
                        properties.userId || "";

                    userInvitationDto.email =
                        properties.email || "";
                }

            }

            return userInvitationDto;
        } catch (error) {
            console.error("Exception occurred while validateInvitation:", error);
            throw error;
        }
    }
}
